<template>
  <div class="k-navbar__dropdown" v-click-outside="close">
    <button class="k-navbar__action-btn" :class="{ 'k-navbar__action-btn--active': isOpen }" @click="toggle" aria-label="Chat">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      </svg>
      <span v-if="openCount > 0" class="k-navbar__badge">{{ openCount }}</span>
    </button>
    <div v-if="isOpen" class="k-navbar__dropdown-menu k-navbar__dropdown-menu--right k-navbar__dropdown-menu--chat">
      <div class="k-navbar__dropdown-header">
        <span>Offene Chats</span>
        <router-link class="k-navbar__dropdown-clear" :to="chatRoute" @click.native="close">Alle anzeigen</router-link>
      </div>
      <div class="k-navbar__dropdown-list">
        <router-link v-for="chat in topChats" :key="chat.id" class="k-navbar__chat-item" :to="chatRoute" @click.native="close">
          <div class="k-navbar__chat-dot" :class="chat.status === 'offen' ? 'dot--open' : 'dot--resolved'"></div>
          <div class="k-navbar__chat-content">
            <p class="k-navbar__chat-subject">{{ chat.metric }} — <span class="chat-sender">{{ chat.sender }}</span></p>
            <span class="k-navbar__chat-preview">{{ chat.lastMessage }}</span>
          </div>
        </router-link>
        <div v-if="topChats.length === 0" class="k-navbar__dropdown-empty">Keine offenen Chats</div>
      </div>
    </div>
  </div>
</template>

<script>
import authStore, { UserRoles } from "@/stores/authStore";

/**
 * NavbarChat — Sprechblasen-Icon mit Dropdown-Vorschau offener KPI-Chats
 * @description Zeigt Badge mit Anzahl offener Chats, Klick öffnet Dropdown mit Preview.
 */
export default {
  name: "NavbarChat",
  directives: {
    clickOutside: {
      bind(el, binding) { el._coHandler = (e) => { if (!(el === e.target || el.contains(e.target))) binding.value(e); }; document.addEventListener("click", el._coHandler); },
      unbind(el) { document.removeEventListener("click", el._coHandler); },
    },
  },
  data() {
    return {
      isOpen: false,
      chats: [
        { id: 1, metric: "MRR", sender: "Kevin Dieckmann", role: "CEO", lastMessage: "Warum ist der MRR diesen Monat gefallen?", status: "offen" },
        { id: 2, metric: "Burn Rate", sender: "Max Mustermann", role: "Investor", lastMessage: "Können wir die Burn Rate senken?", status: "offen" },
        { id: 3, metric: "Churn Rate", sender: "Lisa Kern", role: "Mitarbeiter", lastMessage: "Habe die Auswertung angehängt.", status: "geklärt" },
      ],
    };
  },
  computed: {
    openCount() { return this.chats.filter(c => c.status === "offen").length; },
    topChats() { return [...this.chats].sort((a, b) => (a.status === "offen" ? 0 : 1) - (b.status === "offen" ? 0 : 1)).slice(0, 5); },
    chatRoute() {
      const role = authStore.role;
      if (role === UserRoles.INVESTOR) return { name: "investor-chat" };
      return { name: "entrepreneur-chat" };
    },
  },
  methods: {
    toggle() { this.isOpen = !this.isOpen; },
    close() { this.isOpen = false; },
  },
};
</script>

<style scoped>
.k-navbar__dropdown-menu--chat { width: 340px; }
.k-navbar__chat-item { display: flex; align-items: flex-start; gap: 10px; padding: 10px 16px; text-decoration: none; color: inherit; transition: background .15s; }
.k-navbar__chat-item:hover { background: rgba(255,255,255,.04); }
.k-navbar__chat-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; margin-top: 6px; }
.dot--open { background: var(--k-warning, #ff9500); }
.dot--resolved { background: var(--k-success, #34c759); }
.k-navbar__chat-content { min-width: 0; }
.k-navbar__chat-subject { font-size: 13px; font-weight: 500; color: var(--k-text-primary); margin: 0 0 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.chat-sender { font-weight: 400; color: var(--k-text-tertiary); }
.k-navbar__chat-preview { font-size: 12px; color: var(--k-text-tertiary); display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
</style>
